import FadeUp from "./FadeUp";

const images = Array.from(
    { length: 11 },
    (_, i) => `/showcase/ugc-${String(i + 1).padStart(2, "0")}.webp`
);

const Card = ({ src, i }) => (
    <div className="flex-none w-56 md:w-64">
        <div className="relative aspect-[3/4] rounded-2xl overflow-hidden border border-white/10 bg-white/5">
            <img
                src={src}
                alt={`Creator content ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover object-top"
                loading="lazy"
            />
        </div>
    </div>
);

export const ContentShowcase = () => {
    const loop = [...images, ...images];
    return (
        <section
            id="content-showcase"
            data-testid="content-showcase-section"
            className="py-20 md:py-28 bg-[#0A0A0A] text-white overflow-hidden grain-overlay"
        >
            <div className="container-page">
                <div className="max-w-3xl">
                    <FadeUp>
                        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#C6F432]">
                            Content Showcase
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.05}>
                        <h2
                            data-testid="content-showcase-heading"
                            className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.3] text-white text-balance"
                        >
                            A few recent contents.
                        </h2>
                    </FadeUp>                </div>
            </div>

            <div className="mt-14 marquee-mask">
                <div className="flex gap-5 md:gap-6 animate-marquee w-max">
                    {loop.map((src, i) => (
                        <Card key={i} src={src} i={i % images.length} />
                    ))}
                </div>
            </div>

            <div className="container-page mt-14 flex flex-wrap items-center justify-between gap-6">
                <p className="text-sm text-white/60 max-w-md">
                    A reusable library of UGC, native posts and ad creative,
                    yours to repurpose across paid and organic.
                </p>
                <div className="flex items-center gap-8 text-xs uppercase tracking-[0.2em] text-white/40">
                    <span>10,000+ assets</span>
                    <span className="hidden sm:inline">·</span>
                    <span className="hidden sm:inline">70+ brands</span>
                    <span className="hidden md:inline">·</span>
                    <span className="hidden md:inline">8 years</span>
                </div>
            </div>
        </section>
    );
};

export default ContentShowcase;
